import React from 'react'

import { css } from '@emotion/react'
import styled from '@emotion/styled'

import CloseIcon from '../icons/CloseIcon'
import { getErrorLinkStyle, getWarningLinkStyle } from '../styles'

export type ServiceMessageVariant = 'warning' | 'error'

export interface ServiceMessageProps {
  message: React.ReactNode
  variant?: ServiceMessageVariant
  dismissible?: boolean
  onDismiss?: () => void
}

const Container = styled.div<{ variant?: ServiceMessageVariant }>`
  display: flex;
  padding: 1rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  width: 100%;

  color: ${props => props.theme.colors.bannerTextWarn};
  background: ${props => props.theme.colors.bannerBackgroundWarn};

  p {
    flex-grow: 1;
  }

  a {
    ${props => getWarningLinkStyle(props.theme)};
  }

  ${props =>
    props.variant === 'error' &&
    css`
      color: ${props.theme.colors.bannerTextError};
      background: ${props.theme.colors.bannerBackgroundError};

      a {
        ${getErrorLinkStyle(props.theme)};
      }
    `}
`

const CloseButton = styled.button`
  font-size: 1.5rem;
  width: 1em;
  height: 1em;
  margin-left: 0.625rem;
  appearance: none;
  background: transparent;
  border: none;
  padding: 0;
  color: inherit;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`

const ServiceMessage = ({ message, variant, dismissible, onDismiss }: ServiceMessageProps) => {
  return (
    <Container variant={variant}>
      <p>{message}</p>
      {dismissible && (
        <CloseButton aria-label="close" onClick={() => onDismiss?.()}>
          <CloseIcon />
        </CloseButton>
      )}
    </Container>
  )
}

export default ServiceMessage
